import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  EventEmitter,
  inject,
  OnInit,
  Output,
  signal,
  ViewChild,
} from '@angular/core';
import {CdkMenu, CdkMenuTrigger} from '@angular/cdk/menu';
import {RouterLink} from '@angular/router';
import {MatCardModule} from '@angular/material/card';
import {AuthService} from '../../../core/services/auth.service';
import {MatBadgeModule} from '@angular/material/badge';
import {NgClass} from '@angular/common';
import {MatButton} from '@angular/material/button';
import {NavbarClickableContainerComponent} from './navbar-clickable-container/navbar-clickable-container.component';
import {MatDialog} from '@angular/material/dialog';
import {ExtractComponent} from '../../../pages/reports/extract/extract.component';
import {ScheduleReportCardModalComponent} from '../../../pages/reports/components/schedule-report-card-modal/schedule-report-card-modal.component';
import {BreadcrumbComponent} from '../breadcrumb/breadcrumb.component';
import {EretailMenuWrapperComponent} from '../../components/menu/eretail-menu-wrapper/eretail-menu-wrapper.component';
import {CdkOverlayOrigin, OverlayModule} from '@angular/cdk/overlay';
import {UserService} from '../../../core/services/user.service';
import {IEretailUser} from '../../../core/models/user/eretailUser';
import {ToastService} from '../../../core/helpers/toast.service';
import {ConfirmExitDialog} from './confirm-exit-dialog/confirm-exit-dialog.component';
import {ItemCloseMenuDirective} from '../../components/menu/directives/item-close-menu.directive';
import {HasPermissionDirective} from 'src/app/core/directives/HasPermissionDirective';
import {InstanceService} from 'src/app/core/services/instance.service';
import {PermissionService} from 'src/app/core/util/services/permission.service';
import {HasNotPermissionDirective} from 'src/app/core/directives/HasNotPermission.directive';
import {EditMyPasswordDialogComponent} from 'src/app/pages/configs/components/edit-my-password-dialog/edit-my-password-dialog.component';
import * as updates from 'src/assets/updates/updates.json';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    CdkMenu,
    RouterLink,
    MatCardModule,
    MatBadgeModule,
    NgClass,
    MatButton,
    NavbarClickableContainerComponent,
    BreadcrumbComponent,
    EretailMenuWrapperComponent,
    OverlayModule,
    ItemCloseMenuDirective,
    HasPermissionDirective,
    HasNotPermissionDirective,
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  readonly _dialog = inject(MatDialog);
  private _auth = inject(AuthService);
  private _user = inject(UserService);
  private _toast = inject(ToastService);
  private _instance = inject(InstanceService);
  protected _permission = inject(PermissionService);
  private _http = inject(HttpClient);

  instanceName!: string;

  getUpdates = (): any => updates;
  sysVersion!: string;

  @ViewChild(CdkOverlayOrigin, {static: true}) trigger!: CdkOverlayOrigin;
  menuReportOpen = false;
  menuNotificationOpen = false;
  menuAddShortcutsOpen = false;
  menuProfileOpen = false;

  currentUser = signal<IEretailUser>({} as IEretailUser);

  @Output('collapseMenu')
  collapseMenu: EventEmitter<boolean> = new EventEmitter();

  isMenuCollapsed = false;

  theme = signal<'light' | 'dark'>('light');

  constructor() {
    this._http.get<any[]>('assets/updates/updates.json').subscribe(
      (data) => {
        if (data && data.length > 0) {
          this.sysVersion = data[0].versao;
         
        }
      },
      (error) => console.error('Erro ao carregar Versão:', error)
    );
    this.getCurrentUser();
    this.instanceName = this._instance.getCurrentInstance();
  }

  logOut(): void {
    this._dialog.open(ConfirmExitDialog);
  }

  toggleThemeMode(): void {
    this.theme() === 'light' ? this.theme.set('dark') : this.theme.set('light');

    // window.alert('Opa! Ainda não é possível apagar as luzes D:')
  }

  toggleMenuCollapse(): void {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this.collapseMenu.emit(this.isMenuCollapsed);
  }

  openExtractReportDialog(): void {
    this._dialog.open(ExtractComponent);
  }

  openAddScheduledReportDialog(): void {
    this._dialog.open(ScheduleReportCardModalComponent, {
      data: {
        isDialog: true,
      },
    });
  }
  openPasswordDialog() {
    this._dialog.open(EditMyPasswordDialogComponent),
      {
        data: {
          isDialog: true,
        },
      };
  }
  getCurrentUser(): void {
    const user = this._user.currentUser;
    if (user) {
      this.currentUser.set(user);
    } else {
      this._toast.showErrorToast('Erro', 'Falha ao tentar obter os dados do usuário atual.');
      this._auth.logout();
    }
  }
}
